import RewardOverviewTable from './RewardOverviewTable'

export default RewardOverviewTable
